export default __webpack_public_path__ + "static/media/scales.89b09586.png";